import { render } from "./TableListHeader.vue?vue&type=template&id=0332becc&scoped=true"
import script from "./TableListHeader.vue?vue&type=script&lang=js"
export * from "./TableListHeader.vue?vue&type=script&lang=js"

import "./TableListHeader.vue?vue&type=style&index=0&id=0332becc&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0332becc"]])

export default __exports__